<template>
    <div class="layout">
        <my-head></my-head>
        <div class="main_content">
            <div class="slider">
                <el-menu  :default-active="defaultRouter"  @open="handleOpen" router  :unique-opened="true" :collapse-transition="false" :collapse="false"  background-color="#fbe9e6" text-color="#000"
                    active-text-color="#f4f4f5">
                    <el-submenu   :index="item.path" v-for="(item, index) in routeList" :key="index">
                        <template slot="title">
                            <span>{{ item.title }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item  v-for="(pro, idx) in item.child" :key="idx" :index="pro.path">{{ pro.title
                            }}</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="right_content">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import myHead from './myHead.vue'
export default {
    components: {
        myHead
    },
    watch: {
        $route(to, from){
            if (to.path === '/application/speedApply') {
                this.defaultRouter = 'speedApply'
            }else if (to.path === '/application/apply') {
                this.defaultRouter = 'apply'
            }
        }
    },
    data() {
        return {
            routeList: [
                {
                    title: '教学点申请',
                    path: 'application',
                    child: [
                        {
                            title: '新点申请',
                            path: 'apply',
                        },
                        {
                            title: '申请信息管理',
                            path: 'speedApply',
                        }
                    ]
                }
            ],
            defaultRouter: ''
        }
    },
    methods: {
        handleOpen(key,list){
            console.log(key,list);
        }
    },
    created() {
        if (this.$route.matched.length == 1) {
            this.defaultRouter = 'apply'
        }else if (this.$route.matched.length == 2) {
            this.defaultRouter  = this.$route.matched[1].name
        }
    }
}
</script>
<style lang="less" scoped>
.layout {
    height: 100%;

    .main_content {
        height: calc(~"100% - 100px");
        display: flex;

        .slider ::v-deep {
            // background: red;
            width: 210px;
            height: 100%;
            background: #fbe9e6;

            .submenu-title-noDropdown,
            .el-submenu__title {
                &:hover {
                    background-color: #ba2a17 !important;
                    color: white !important;
                }
            }

            .is-active>.el-submenu__title {
                color: #f4f4f5 !important;
                background: #fbe9e6 !important;
                color: black !important;
                font-weight: bold;
                // opacity: 0.98;
            }

            & .nest-menu .el-submenu>.el-submenu__title,
            & .el-submenu .el-menu-item {
                // min-width: $sideBarWidth !important;
                background-color: #fbe9e6 !important;

                &:hover {
                    background-color: #ba2a17 !important;
                    color: white !important;
                }
            }

            & .el-submenu .el-menu-item {
                // min-width: $sideBarWidth !important;
                background-color: #fbe9e6 !important;
                color: rgb(88, 86, 86) !important;
                font-size: 12px !important;

                &:hover {
                    background-color: #ba2a17 !important;
                }
            }

            & .el-submenu .el-menu-item.is-active {
                background-color: #ba2a17 !important;
                color: white !important;
            }
            .el-menu-item-group__title{
                display: none;
            }
        }

        .right_content {
            flex: 1;
            overflow-y: auto;
            height: 100%;
        }
    }
}
</style>